import styled from 'styled-components';
import { rem } from 'polished';
import Config from '@config';
import Heading from '@atoms/Heading/Heading';
import Button from '@atoms/Button/Button';

export const DeliveryPickerWrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
  padding: ${rem(20)};
  height: 100%;
  position: relative;

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    width: ${rem(420)};
  }
`;

export const StyledDeliveryPickerHeading = styled(Heading)`
  text-align: center;
  padding: ${rem(20)} 0 ${rem(8)} 0;
`;

export const StyledBackButton = styled(Button)`
  position: absolute;
  top: ${rem(20)};
  left: ${rem(20)};
`;
